import { IonCol, IonGrid, IonPage, IonRow } from '@ionic/react'
import { Feedback, Modal } from 'app-principal-componentes-visuales'
import React, { useContext, useState } from 'react'
import { ASISTENCIA_CREADA, HOME, TITULO_PREGUNTA } from '../../utils/constants';
import { capitalizeString } from '../../utils/utils';
import Contactanos from '../../components/Modals/Contactanos/Contactanos'
import { AsistenciaMedicaContext } from '../../contexts/AsistenciaMedicaContext';
import { TextoComponente } from '../../interfaces/textoComponente.interface';

const FeedbackServicioEnCurso = ({history}) => {

  const [showContactanosModal, setShowContactanosModal] = useState(false);

  const { setupData, asistenciaMedica, isWeb } = useContext(AsistenciaMedicaContext);

  let { socio } = history.location.state;

  const textoAsistenciaEnCurso: TextoComponente = asistenciaMedica.textoComponentes.find((textoComponente) => textoComponente.componente === "Asistencia error en curso");

  const handleVolverInicio = () => {
    history.push(HOME, { seguimiento : false, from: ASISTENCIA_CREADA });
  }

  const openModalContactanos = () => {
      setShowContactanosModal(!showContactanosModal);
  };

  return (
    <IonPage>
    <div className="asistencia-error_page feedbackServicioEnCurso">
        <IonGrid className={`${isWeb ? 'asistencia_content-container asistencia-web-mobile-padding' : ''} asistencia-error_page`} >
            <IonRow>
                <IonCol size='12'>
                <Feedback
                    asistencia
                    handsPhoneError
                    labelButtonCancel={textoAsistenciaEnCurso.botones.find(txt => txt.nombre === 'volver-inicio-ec' ).texto}
                    labelButtonOk={textoAsistenciaEnCurso.botones.find(txt => txt.nombre === 'contactanos-ec').texto}
                    onClickCancel={handleVolverInicio}
                    onClickOk={openModalContactanos}
                    titulo={textoAsistenciaEnCurso.titulo}
                    parrafo={textoAsistenciaEnCurso.subtitulo.replace("$nombre", capitalizeString(socio.nombre))}
                    id="feedback-asistencia-solicitada-contactanos"
                />
                </IonCol>
            </IonRow>
        </IonGrid>
        <Modal
            className='modal_web'
            hideCloseBtn={false}
            //@ts-ignore
            component={<Contactanos setupData={setupData} screen={'servicio_vigente'} sintomas texto={null} titulo={TITULO_PREGUNTA} />}
            setShowModal={setShowContactanosModal}
            showModal={showContactanosModal}
            id='contactanos'
        />
    </div>
    </IonPage>
  )
}

export default FeedbackServicioEnCurso